<template>
  <page>
    <div :id="categoryId" :class="categoryId" class="m-grid__item m-grid__item--fluid m-wrapper ls-custom-page" v-if="category">

      <!-- BEGIN: Subheader -->
      <div :class="categoryId" class="m-subheader" >
        <div class="align-items-center break-word">
          <div class="mr-auto">
            <h1 :class="categoryId" class="m-subheader__title full-max-width" v-encode="category.name"></h1>
          </div>
        </div>
      </div>
      <!-- END: Subheader -->

      <div v-if="pages.length" class="m-content">
        <div class="row">
          <categorypage v-for="page in pages.slice(0, showOnPage)" :page="page" :key="page.uuid"></categorypage>
        </div>
        <div v-if="isThereMore" class="row">
          <div class="col m--align-center">
            <button type="button" class="btn btn-sm m-btn--custom m-btn--pill btn-ls"
                    @click="showMore">{{$t('Load more')}}
            </button>
          </div>
        </div>
      </div>

      <div class="m-content" v-if="!pages.length">
        <div class="m-portlet m-portlet--full-height">
          <div class="m-portlet__body">
            <div class="tab-content">
              <div class="tab-pane active" id="m_widget2_tab1_content" aria-expanded="true">
                {{$t('No articles')}}
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </page>
</template>

<script>
import {mapActions} from 'vuex'
import Encode from "@/directives/encode";
import Page from "./Page";
import iframeResize from 'iframe-resizer/js/iframeResizer';
import http from "@/axios";
import {fail, finish, start} from "@/utils/Progress";
import {entityUuidFromLocation} from "@/utils/EntityUuid";
import store from "@/store";
import Categorypage from "@/components/page/Page.vue";

export default {
  name: "CategoryPage",
  components: {Categorypage, Page},
  directives: {Encode},
  data() {
    return {
      iframes: [],
      category: null,
      categoryId: '',
      pages: [],
      showOnPage: 6
    };
  },
  beforeRouteEnter(to, from, next) {
    start();

    const storageKey = 'ls-member-module-' + entityUuidFromLocation();
    const state = JSON.parse(localStorage.getItem(storageKey));

    if (!state) {
      fail();
      next(vm => {
        vm.$router.push({name: 'LoginPage'})
      });
      return;
    }
    http.get(`pagecategory/${to.params.categoryUuid}`, {
      headers: {
        Authorization: `Bearer ${state.auth.token}`
      }
    })
        .then((r) => {
          if(r.data.cookie){
            document.cookie =
                "Token=" + `${state.auth.token}` + ";" + 60*60 + ";path=/mixer";
          }
          next(vm => {
            vm.setCategory(r.data.category)
            vm.setPages(r.data.pages)
          })
          finish();
        })
        .catch((e) => {
          fail();

          if (e.response.status === 403) {
            const matchingRoute = store.getters.getMatchingRoute(to);

            next(vm => {
              vm.setCategory({
                title: matchingRoute ? matchingRoute.title : '',
                content: this.$t('Access denied')
              })
            });

            return;
          }

          next(vm => {
            vm.pushToFirstAvailablePage();
          });
        })
  },
  beforeRouteUpdate(to, from, next) {
    start();

    http.get(`pagecategory/${to.params.categoryUuid}`)
        .then((r) => {
          this.setCategory(r.data.category);
          this.setPages(r.data.pages);
          next();
        })
        .then(() => finish())
        .catch((e) => {
          fail();
          if (e.response.status === 403) {
            const matchingRoute = store.getters.getMatchingRoute(to);

            this.setCategory({
              title: matchingRoute ? matchingRoute.title : '',
              content: this.$t('Access denied')
            })
          } else {
            this.pushToFirstAvailablePage();
          }

          next();
        })
  },
  mounted() {
    this.initIframeResize();
  },
  beforeDestroy() {
    // Sprzątanie postMessage listenerów iframe-resizer'a — bez tego po
    // wyjściu ze strony handler'y żyją w pamięci aż do reload'u.
    if (this.iframes && this.iframes.length) {
      this.iframes.forEach((iframe) => {
        iframe.iFrameResizer && iframe.iFrameResizer.removeListeners();
      });
    }
  },
  methods: {
    ...mapActions([
      'pushToFirstAvailablePage'
    ]),
    initIframeResize(destroy = false) {
      this.categoryId = "category-"+this.$route.params.id;
      if (destroy && this.iframes.length) {
        this.iframes.map((iframe) => {
          iframe.iFrameResizer.removeListeners();
        })
      }
      setTimeout(() => {
        this.iframes = iframeResize({
          checkOrigin: false,
          heightCalculationMethod: 'taggedElement',
          log: false,
        }, '.resize-iframe');
      }, 1);
    },
    setCategory(category) {
      this.$set(this, 'category', category);
    },
    setPages(pages) {
      this.$set(this, 'pages', pages);
    },
    showMore() {
      this.showOnPage += 6;
    },
  },
  computed: {
    isThereMore() {
      return this.pages.length > this.showOnPage;
    },
  },
  watch: {
    page(category) {
      if (category === undefined) {
        this.pushToFirstAvailablePage();
        return;
      }

      this.initIframeResize(true);
    }
  }
}
</script>

<style>
.overflow-x-auto {
  overflow-x: auto;
}

.m-content-ls a {
  color: var(--accent-color) !important;
}

.break-word {
  -ms-word-wrap: break-word;
  word-wrap: break-word;
}

.full-max-width {
  max-width: 100% !important;
}

iframe {
  min-width: 100%;
}
</style>
